import { useContext, useEffect, useState } from "react";
import {
  DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE,
  DEFAULT_CHECKOUT_VAR,
  USER_ROLES,
} from "../constants";
import useLocalStorage from "./useLocalStorage";
import usePractitioner from "./usePractitioner";
import { AppContext } from "lib/contexts/app-context";

const usePractitionerSubscriptionContext = (): CheckoutState => {
  const { getValue, setValue } = useLocalStorage<CheckoutStateVars>();
  const { getPractitionerDetails } = usePractitioner();
  const { appState } = useContext(AppContext);

  const [checkoutState, setCheckoutState] = useState<CheckoutStateVars>(
    getValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE) ??
      DEFAULT_CHECKOUT_VAR
  );

  const validateCheckoutState = (onSuccess?: (status: string) => void) => {
    if (appState.userRole === USER_ROLES.PRACTITIONER) {
      getPractitionerDetails(appState.user_id, (practitioner) => {
        setCheckoutState({ ...checkoutState, practitioner });

        setValue(
          DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE,
          {
            ...checkoutState,
            status: practitioner?.isActive ? "success" : "failed",
          }
        );
        onSuccess?.(practitioner?.isActive ? "success" : "failed");
      });
      // isPractitionerSubscribed(appState.user_id, (response) => {
      //   setValue(
      //     DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE,
      //     {
      //       ...checkoutState,
      //       status: response ? "success" : "failed",
      //     }
      //   );
      //   onSuccess?.(response ? "success" : "failed");
      // });
      //alert("Context initialized");
    }
  };

  useEffect(() => {
    validateCheckoutState();
  }, []);

  const updateCheckoutState = (
    practitionerSubscriptionState: CheckoutStateVars
  ) => {
    setCheckoutState(checkoutState);
    setValue(
      DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE,
      practitionerSubscriptionState
    );
  };

  return {
    checkoutState,
    updateCheckoutState,
    validateCheckoutState,
  };
};

export default usePractitionerSubscriptionContext;
